export class CatalogItem {

  constructor(data) {

    this.code = data.d1;
    this.description = data.d2;
  }
}